module.exports = function anonymous(it
) {
var out='<li> <a data-ajax="false" href="'+(it.href)+'" rel="localize[app.'+(it.name)+']">'+(it.name)+'</a></li>';return out;
}